/** Alinhado a AttendanceSheetDayEnum.INDEFINIDO na API/web. */
export const STATUS_DIA_INDEFINIDO = 1;

export type DiaParaValidacaoAssinatura = {
  dia: number;
  /** YYYY-MM-DD */
  data: string;
  feriado?: string | null;
  /** false = sem registro na folha (mensagem "Faltam..."). */
  cadastrado: boolean;
  status: number | null | undefined;
};

export type ValidarDiasUteisInput = {
  diasLivres: boolean;
  /** true = exige sáb/dom; false = exige seg–sex */
  fimSemana: boolean;
  dias: DiaParaValidacaoAssinatura[];
};

export type ValidarDiasUteisResult =
  | { ok: true }
  | { ok: false; message: string };

function isWeekendDateOnly(data: string): boolean {
  const [y, m, d] = data.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const day = date.getDay();
  return day === 0 || day === 6;
}

export function validarDiasUteisParaAssinatura(
  input: ValidarDiasUteisInput,
): ValidarDiasUteisResult {
  if (input.diasLivres) {
    return { ok: true };
  }

  const diasExigidos = input.dias.filter((d) => {
    if (d.feriado) return false;
    return isWeekendDateOnly(d.data) === input.fimSemana;
  });

  const diasFaltando = diasExigidos.filter((d) => !d.cadastrado);
  if (diasFaltando.length > 0) {
    return {
      ok: false,
      message: `Faltam ${diasFaltando.length} dia(s) útil(is) para preencher na folha de frequência.`,
    };
  }

  const diasIndefinidos = diasExigidos.filter((d) => {
    const status = d.status;
    return (
      status === null ||
      status === undefined ||
      status === STATUS_DIA_INDEFINIDO
    );
  });

  if (diasIndefinidos.length > 0) {
    return {
      ok: false,
      message: `Não é possível enviar para assinatura. ${diasIndefinidos.length} dia(s) útil(is) ainda não estão preenchidos.`,
    };
  }

  return { ok: true };
}
